import type { ReactNode } from "react";
import { createContext, use, useState } from "react";
import Brand from "./Brand";
import dataLayer, { defaultDataLayerData } from "tracking/tools/dataLayer";

type BrandContextType = {
  brand?: Brand;
  updateBrand(brand: Brand | undefined): void;
};

const DEFAULT_BRAND_CONTEXT: BrandContextType = {
  updateBrand() {
    throw new Error("Brand should be used within a brand provider");
  },
};

export const BrandContext = createContext<BrandContextType>(DEFAULT_BRAND_CONTEXT);

export const BrandProvider = ({ children }: { children?: ReactNode }) => {
  const [brand, setBrand] = useState<Brand>();

  return (
    <BrandContext.Provider
      value={{
        brand,
        updateBrand: (newBrand: Brand | undefined) => {
          setBrand(newBrand);
          if (defaultDataLayerData.brand === undefined) dataLayer.setBrand(newBrand?.slug || null);
        },
      }}
    >
      {children}
    </BrandContext.Provider>
  );
};

export const useBrand = () => {
  const brandContext = use(BrandContext);

  return brandContext.brand;
};

export const useBrandUpdate = () => {
  const brandContext = use(BrandContext);
  return brandContext.updateBrand;
};
